module.exports = __webpack_public_path__ + "static/media/SM-ST-O1-wrong.77ef50a8.mp3";